module.exports = __webpack_public_path__ + "static/media/Reducí-intro2-icon.88fe6119.svg";